<div class="app-edited-stations profile-page-content">
  <app-stations-list contributionType="UPDATE" [userId]="userId"></app-stations-list>
</div>
